//
// CrosstabAxis.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./CrosstabAxisType";
import "./CrosstabHierarchy";
import "./CrosstabMeasure";

var CrosstabAxis = createModule("BIRD::CrosstabAxis", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        measures: [1],
        hierarchies: [1],
        type: 4,
        expandDisabledByApp: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default CrosstabAxis;
